var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        [
          _c(
            "v-flex",
            [
              _c(
                _vm.type,
                _vm._b(
                  { tag: "component" },
                  "component",
                  _vm.componentProps,
                  false
                )
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }